import {handledGroupFinTerm} from "../GroupFinTermBlock/defProps";

export const GroupFinTermCardInfoRowDefProps = {
 handledGroupFinTerm: handledGroupFinTerm
};